import { render, staticRenderFns } from "./FormDashboardConfigTable.vue?vue&type=template&id=29c51e10&scoped=true&"
import script from "./FormDashboardConfigTable.vue?vue&type=script&lang=js&"
export * from "./FormDashboardConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./FormDashboardConfigTable.vue?vue&type=style&index=0&id=29c51e10&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c51e10",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QItemSection,QItemLabel,QBtn,QIcon,QSelect});
